import { createReducer, on } from '@ngrx/store';

import { parametersForAdminLockedTable } from '../../modules/shared/constants/parameters.for.calls.constants';
import * as AdminProjectsLockedActions from '../actions/admin-projects-locked.actions';
import { IAdminProjectDataContentSets } from './../../modules/shared/interfaces/admin/admin-project-set-paging.interface';

export interface AdminPojectsLockedState {
  value: IAdminProjectDataContentSets;
  sort: string;
  isScrolling: boolean;
  isSearching: boolean;
  searchParam: string;
}

const initialState: AdminPojectsLockedState = {
    value: {
      content: [],
      first: true,
      last: false,
      number: 0,
      numberOfElements: 0,
      size: 0,
      totalElements: 0,
      totalPages: 1,
      sort: {
        ascending: true,
        descending: false,
        direction: 'ASC',
        ignoreCase: false,
        nullHandling: 'NATIVE',
        property: 'lastExported'
      }
    },
    sort: parametersForAdminLockedTable.sort,
    isScrolling: false,
    searchParam: '',
    isSearching: false
};

export const adminProjectsLockedDataReducer = createReducer<AdminPojectsLockedState>(
  initialState,
  on(AdminProjectsLockedActions.LoadAdminProjectsLocked, (state: AdminPojectsLockedState, { sort }) => {
    return {
      ...state,
      sort,
      isScrolling: false,
      isSearching: false,
      searchParam: ''
    };
  }),
  on(AdminProjectsLockedActions.SortAdminProjectsLocked, (state: AdminPojectsLockedState, { sort }) => {
    return {
      ...state,
      sort,
      isScrolling: false
    };
  }),
  on(AdminProjectsLockedActions.ScrollAdminProjectsLocked, (state: AdminPojectsLockedState, { sort }) => {
    return {
      ...state,
      sort,
      isScrolling: true,
      isSorting: false
    };
  }),
  on(AdminProjectsLockedActions.SearchAdminProjectsLocked, (state: AdminPojectsLockedState, { search }) => {
    return {
      ...state,
      isScrolling: false,
      isSearching: true,
      searchParam: search
    };
  }),
  on(AdminProjectsLockedActions.SearchSortAdminProjectsLocked, (state: AdminPojectsLockedState, { sort }) => {
    return {
      ...state,
      sort,
      isScrolling: false
    };
  }),
  on(AdminProjectsLockedActions.SearchScrollAdminProjectsLocked, (state: AdminPojectsLockedState, { search }) => {
    return {
      ...state,
      isScrolling: true,
      isSearching: true,
      searchParam: search
    };
  }),
  on(AdminProjectsLockedActions.LoadAdminProjectsLockedDataSuccessAction, (
    state: AdminPojectsLockedState, { adminProjectLockedTableItems }) => {
      const value = { ...adminProjectLockedTableItems };

      if (state.isScrolling) {
        value.content =
          state.value.content.concat(adminProjectLockedTableItems.content);
      }

      return {
        ...state,
        value
      };
  })
);

export const getAdminTableProjectsLocked = (state: AdminPojectsLockedState) => state;
export const getAdminTableSortSearchParamLocked = (state: AdminPojectsLockedState) => {
  return {
  sort: state.sort,
  searchParam: state.searchParam
  };
};
